import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchWorkkardByIdRequest, fetchWorkkardByIdSuccess } from '../store/workkardFormSlice';
import { 
  selectFetchedWorkkard, 
  selectIsFetchingWorkkard, 
  selectFetchWorkkardError 
} from '../store/selectors';

export function useWorkkardHydration(workkardId) {
  const dispatch = useDispatch();
  const workkardData = useSelector(selectFetchedWorkkard);
  const isLoading = useSelector(selectIsFetchingWorkkard);
  const error = useSelector(selectFetchWorkkardError);

  useEffect(() => {
    if (workkardId) {
      dispatch(fetchWorkkardByIdRequest({ workkardId }));
    }

    return () => {
      dispatch(fetchWorkkardByIdSuccess(null))
    }
  }, [workkardId, dispatch]);

  return { workkardData, isLoading, error };
}
